import { Component, OnInit, Input, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';

@Component({
  selector: 'app-my-events-calendar',
  templateUrl: './my-events-calendar.component.html',
  styleUrls: ['./my-events-calendar.component.scss']
})
export class MyEventsCalendarComponent implements OnInit {
  @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;
  _calendarData = [];
  events:any=[];
  currentMonth= moment();
  calendarOptions: Options;
  @Input() set calendarData(value: any) {
    this.events = [];
    this._calendarData = value;
    console.log(this._calendarData);
    for(var i in this._calendarData) {

        if(!this._calendarData[i].date) {
        continue;
        }
        let obj = {
        "backgroundColor":"#eff3f9",
        "allDay":true,
        "start": moment(this._calendarData[i].date).local(),
        "data" : this._calendarData[i]
        }
        this.events.push(obj);
    
        }
        if(this.events.length>0)  {
          console.log("events123", this.events);
            this.calendarOptions = {
            editable: false,
            eventLimit: false,
            timezone: 'UTC',
            selectable:false,
            defaultDate : this.currentMonth,
            header: {
            left: 'prev,next today',
            center: 'title',
            right: 'month,agendaWeek,agendaDay,listMonth'
            },
            events: this.events,
            eventRender: (v, el) => { console.log('v, el')}
          };
        }
  }
  get calendarData(): any {
    return this._calendarData;
  }
  constructor() { }

  ngOnInit() {
  }

  eventRender(e) {
    console.log("e",e);
      let programId = e.event.data.eventId;
      let stateName = e.event.data.stateName || '';
      let city = e.event.data.city || '';
      let topic = e.event.data.topic == null ? '' : e.event.data.topic;
      let seriesName = e.event.data.seriesName == null ? '' : e.event.data.seriesName;
      let meetingTypeId = e.event.data.meeting_type_id ? e.event.data.meeting_type_id: '';
      let timeZone = e.event.data.time_zone ? e.event.data.time_zone + ', ': '';
      let location = '';
      if(meetingTypeId != 2) {
        location = (city ? city + ', ': '') + (stateName ? stateName + ', ': '');
      }
      let eventStart = e.event.data.event_start_time != null  ? moment(e.event.data.event_start_time, ["h:mm"]).format("h:mm A"): '';
      let eventEnd = e.event.data.event_end_time != null  ? moment(e.event.data.event_end_time, ["h:mm"]).format("h:mm A") + `, `: '';
      
      let calHtml = eventStart + (eventEnd ? ` - `: ', ') + eventEnd + timeZone + programId;
      console.log(calHtml)
      let html = `<div style="font-size: 11px;color: black;padding: 5px;">
      `+ calHtml +`
      </div>
      <div style="font-size: 11px;color: #3457bb;padding: 5px;">
           <a href="/event/details/` + programId + `">` + seriesName + `</a>
      </div>
      </div>
      <div class="icon-panel text-right" style="margin-bottom:5px;">
        </div>  `;
      e.element.html(html)
    }
    // `<a [routerLink]="[` + `'/event/details/`  + programId + `']">`
}
